/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, Injectable, OnDestroy } from '@angular/core';
import { NotificationConfig } from './notification-config';
import { NotificationComponent } from './notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService implements OnDestroy {
  private overlayRef: OverlayRef;
  private notificationComponentRef: ComponentRef<NotificationComponent>;

  constructor(private overlay: Overlay) {}

  show<D = any>(notificationConfig: NotificationConfig<D>): void {
    if (!this.overlayRef?.hasAttached()) {
      this.notificationComponentRef = this.attachDialogContainer();
    }
    this.notificationComponentRef.instance.push(notificationConfig);
  }

  ngOnDestroy(): void {
    if (this.overlayRef?.hasAttached()) {
      this.overlayRef.detach();
      this.notificationComponentRef = null;
    }
  }

  private attachDialogContainer(): ComponentRef<NotificationComponent> {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().centerHorizontally().top(),
      panelClass: 'notifications-panel'
    });

    // setting higher z-index to show notification above other cdk overlays
    this.overlayRef.hostElement.style.zIndex = '2000';
    return this.overlayRef.attach(new ComponentPortal(NotificationComponent));
  }
}
